import gql from 'graphql-tag';

import { eventFragment } from '~/shared/graphql-queries/events';

export default gql`
    query findByIdEventQuery($_id: MongoID!) {
        findByIdEventQuery(_id: $_id) {
            ...EventFragment
        }
    }

    ${eventFragment}
`;
